import PropTypes from 'prop-types'
import { useMemo } from 'react'
import styles from './Filtros.module.css'
import { RadioInput } from './RadioInput'

const MAX_OPCIONES_VISIBLES = 5

export const FiltroEmpresaUsuario = ({
  campo,
  titulo,
  arbol,
  empresaSeleccionada,
  usuarioSeleccionado,
  onChangeEmpresa,
  onChangeUsuario,
  onVerTodas
}) => {
  const empresaActual = arbol.find((emp) => String(emp.valor) === String(empresaSeleccionada))

  const opcionesEmpresaOrdenadas = useMemo(() => {
    if (
      empresaSeleccionada === null ||
      empresaSeleccionada === undefined ||
      empresaSeleccionada === ''
    ) {
      return arbol
    }
    return [...arbol].sort((a, b) => {
      if (String(a.valor) === String(empresaSeleccionada)) return -1
      if (String(b.valor) === String(empresaSeleccionada)) return 1
      return 0
    })
  }, [arbol, empresaSeleccionada])

  return (
    <div className={styles.filtroItem}>
      <h3>{titulo}:</h3>
      {opcionesEmpresaOrdenadas.slice(0, MAX_OPCIONES_VISIBLES).map(({ label, valor }) => (
        <RadioInput
          key={valor}
          valor={label}
          isSelected={String(empresaSeleccionada) === String(valor)}
          onClick={(l) => {
            if (l === label) {
              onChangeEmpresa(valor)
            } else {
              onChangeEmpresa('')
              onChangeUsuario('')
            }
          }}
        />
      ))}
      {arbol.length > MAX_OPCIONES_VISIBLES && (
        <span
          className={styles.verMas}
          onClick={() => onVerTodas(arbol, `${campo}Empresa`, titulo)}
        >
          Ver Todas
        </span>
      )}

      {empresaActual && empresaActual.usuarios.length > 0 && (
        <div className={styles.filtroItem}>
          <h3>{empresaActual.label}:</h3>
          {empresaActual.usuarios.slice(0, MAX_OPCIONES_VISIBLES).map(({ label, valor }) => (
            <RadioInput
              key={valor}
              valor={label}
              isSelected={String(usuarioSeleccionado) === String(valor)}
              onClick={(l) => onChangeUsuario(l === label ? valor : '')}
            />
          ))}
          {empresaActual.usuarios.length > MAX_OPCIONES_VISIBLES && (
            <span
              className={styles.verMas}
              onClick={() =>
                onVerTodas(empresaActual.usuarios, `${campo}Usuario`, empresaActual.label)
              }
            >
              Ver Todas
            </span>
          )}
        </div>
      )}
    </div>
  )
}

FiltroEmpresaUsuario.propTypes = {
  campo: PropTypes.oneOf(['comprador', 'vendedor']).isRequired,
  titulo: PropTypes.string.isRequired,
  arbol: PropTypes.arrayOf(
    PropTypes.shape({
      valor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string,
      usuarios: PropTypes.array
    })
  ).isRequired,
  empresaSeleccionada: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  usuarioSeleccionado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChangeEmpresa: PropTypes.func.isRequired,
  onChangeUsuario: PropTypes.func.isRequired,
  onVerTodas: PropTypes.func.isRequired
}
